// Filename - pages/Services.js

import React from "react";

export const Services = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Services
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export const DirectoryService = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Internal Directory Services
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export const AppHosting = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Internal Application Hosting Services
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export const InternalReporting = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Internal Reporting Services
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};
